/**
 * Three-way evidence-tag toggle (Grounded / Assumed / Inferred) used by the
 * structured-artifact editors.
 */

import React from 'react';
import { cn } from '@ideoz/ui';
import type { EvidenceTag } from './evidence';

const TAGS: EvidenceTag[] = ['Grounded', 'Assumed', 'Inferred'];

export const TagToggle: React.FC<{
  value: EvidenceTag | null;
  onChange: (t: EvidenceTag) => void;
}> = ({ value, onChange }) => (
  <div className="inline-flex overflow-hidden rounded-md border border-gray-200 dark:border-gray-700">
    {TAGS.map((t) => {
      const active = value === t;
      const activeCls =
        t === 'Grounded'
          ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/50 dark:text-emerald-200'
          : t === 'Inferred'
            ? 'bg-sky-100 text-sky-800 dark:bg-sky-900/50 dark:text-sky-200'
            : 'bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200';
      return (
        <button
          key={t}
          type="button"
          onClick={() => onChange(t)}
          className={cn(
            'px-2 py-0.5 text-[11px] font-medium transition-colors',
            active ? activeCls : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'
          )}
        >
          {t}
        </button>
      );
    })}
  </div>
);
